// ── EMAIL NAMES AND DESCRIPTIONS, FROM THE ONE PLACE THEY LIVE ───────────────
//
// Every email's name and trigger description is stored in ry_sequence_emails
// (edited in Booking Hub's Email > Funnel tab) and read here through
// GET /api/admin/sequence-emails. The admin keeps NO copy of that wording in
// code: the Email Stats tab (AdminEmail.jsx) and the clients page (Admin.jsx)
// keep only structure — which emails, in which group, in what order — and take
// every word from here.
//
// NO HARDCODED FALLBACK. An email with nothing stored, or a failed load, shows
// NO_DESCRIPTION rather than a guess. Loaded once per visit and shared.

import { useEffect, useState } from 'react';
import { getSequenceEmails } from '../../utils/api';

export const NO_DESCRIPTION = 'No description set';

let cache = null;      // { bySeq: { [email_events sequence]: row } }
let inflight = null;

function load() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = getSequenceEmails()
      .then((res) => {
        const bySeq = {};
        for (const row of res.data || []) if (row && row.sequence) bySeq[row.sequence] = row;
        cache = { bySeq };
        return cache;
      })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** { bySeq, ready, failed } — ready once the load has finished either way. */
export function useSequenceEmails() {
  const [state, setState] = useState(cache ? { ...cache, ready: true, failed: false } : { bySeq: {}, ready: false, failed: false });
  useEffect(() => {
    if (cache) return undefined;
    let active = true;
    load()
      .then((c) => { if (active) setState({ ...c, ready: true, failed: false }); })
      .catch(() => { if (active) setState({ bySeq: {}, ready: true, failed: true }); });
    return () => { active = false; };
  }, []);
  return state;
}

/**
 * The stored name and trigger description for an email_events sequence key.
 * null where nothing is stored — the caller shows NO_DESCRIPTION, never
 * wording of its own.
 */
export function storedEmailCopy(state, seqKey) {
  const row = state && state.bySeq ? state.bySeq[seqKey] : null;
  return {
    name: (row && row.name) || null,
    trigger: (row && row.trigger_description) || null,
  };
}
